import { useResizeObserver } from '@vueuse/core';

export const useIsMobile = () => useState<boolean>('isMobile');

export const useResizeObserverGlobal = () => {
  const isMobile = useIsMobile();
  const observedEl = shallowRef<HTMLDivElement | null>(null);
  const resizeObserverEntry = ref<ResizeObserverEntry | undefined>();

  useResizeObserver(observedEl, (entries) => {
    resizeObserverEntry.value = entries[0];
  });

  const isMobileFromResizeObserver = computed(
    () =>
      !!resizeObserverEntry.value?.contentRect.width
      && resizeObserverEntry.value.contentRect.width <= 639,
  );

  watch(isMobileFromResizeObserver, (value) => {
    isMobile.value = value;
  });

  const vResponsive = {
    mounted: (el: HTMLDivElement) => {
      observedEl.value = el;
    },
    unmounted: () => {
      observedEl.value = null;
    },
  };

  return {
    vResponsive,
    isMobile,
  };
};
